module.exports = __webpack_public_path__ + "img/img-not-found.d4eb7b90.jpg";